import { WhatsAppCountry } from '@api/types/whatsappNumber';
import { RENTENNIALS_WHATSAPP_SUPPORT, RENTENNIALS_WHATSAPP_SUPPORT_US } from '@constants/index';

export const getWhatsAppCountry = (country?: string) => {
  if (country && (country.toLowerCase() === 'estados unidos' || country.toLowerCase() === 'us')) {
    return WhatsAppCountry.USA;
  }
  return WhatsAppCountry.ALL;
};

const isWhatsAppCountry = (data: unknown): data is WhatsAppCountry => {
  return !!data && typeof data === 'string' && Object.keys(WhatsAppCountry).includes(data);
};

const whatsappCountryNumberMap: { [key in WhatsAppCountry]: string } = {
  ALL: RENTENNIALS_WHATSAPP_SUPPORT,
  USA: RENTENNIALS_WHATSAPP_SUPPORT_US
};

export const getCountryNumber = (whatsAppCountry?: string | WhatsAppCountry) => {
  return whatsappCountryNumberMap[isWhatsAppCountry(whatsAppCountry) ? whatsAppCountry : WhatsAppCountry.ALL];
};
